// extracted by mini-css-extract-plugin
export default {"view_info_container":"styles_view_info_container__15Y14","label":"styles_label__ATebv","data":"styles_data__fe7dW","colon":"styles_colon__VcOWs"};